import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import backendService from './backend_services';

import Home_Page from './pages/Home_Page';
import LearnMore from './pages/Learn_More';
import Book_Page from './pages/Book_Page';
import Profile_Page from './pages/Profile_Page';
import Login_Page from './pages/Login_Page';
import Signup_Page from './pages/Sign-up_Page';
import Forgot_Password from './pages/Forgot_Password';
import Reset_Password from './pages/Reset_Password';
import Manage_Users from './pages/Manage_Users';
import Booking_Success_Page from './pages/Booking_Success_Page';
import Manage_Bookings from './pages/Manage_Bookings';
import Find_Booking_Page from './pages/Find_Booking_Page';
import Privacy_Policy from './pages/Privacy_Policy';
import Terms_Conditions from './pages/Terms_Conditions';
import NotFound from './pages/NotFound';
import './App.css';

function App() {
  useEffect(() => {
    // Initialize backend service when app starts
    backendService.startHealthChecks();
    
    // Cleanup on app unmount
    return () => {
      backendService.stopHealthChecks();
    };
  }, []);

  return (
    <div className="app">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login_Page />} />
          <Route path="/signup" element={<Signup_Page />} />
          <Route path="/forgot-password" element={<Forgot_Password />} />
          <Route path="/reset-password" element={<Reset_Password />} />
          <Route path="/" element={<Home_Page />} />
          <Route path="/learn-more" element={<LearnMore />} />
          <Route path="/book-page" element={<Book_Page />} />
          <Route path="/profile-page" element={<Profile_Page />} />
          <Route path="/manage-users" element={<Manage_Users />} />
          <Route path="/booking-success" element={<Booking_Success_Page />} />
          <Route path="/manage-bookings" element={<Manage_Bookings />} />
          <Route path="/find-booking" element={<Find_Booking_Page />} />
          <Route path="/privacy-policy" element={<Privacy_Policy />} />
          <Route path="/terms-conditions" element={<Terms_Conditions />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
